// src/footer.tsx
import { Link, Stack, styled, Typography } from "@mui/material";
import { useLocaleContext, useT } from "@clara/locale";
import { Flex } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.tokens.gray30,
  textDecoration: "none",
  fontWeight: 400,
  border: `2px solid ${theme.palette.tokens.white}`,
  "&:hover": {
    color: theme.palette.tokens.gray40
  },
  "&:focus": {
    border: `2px solid ${theme.palette.tokens.blue20}`
  }
}));
StyledLink.defaultProps = {
  variant: "caption",
  target: "_blank"
};
function Footer() {
  const { t } = useT("common");
  const { locale } = useLocaleContext();
  const { links } = locale.preferences.metadata;
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      "data-testid": "footer",
      component: "footer",
      flexDirection: { xs: "column-reverse", md: "row" },
      justifyContent: { xs: "center", md: "space-between" },
      alignItems: "center",
      sx: {
        bgcolor: "v3.bg.alternative",
        py: 2,
        px: { xs: 1, sm: 3 },
        borderTop: (theme) => `1px solid ${theme.palette.tokens.slate60}`,
        minHeight: (theme) => theme.spacing(7)
      },
      children: [
        /* @__PURE__ */ jsxs(
          Typography,
          {
            "data-testid": "footer-copyright",
            variant: "caption",
            sx: { color: (theme) => theme.palette.tokens.gray30 },
            children: [
              /* @__PURE__ */ jsx(
                Flex,
                {
                  component: "span",
                  dangerouslySetInnerHTML: { __html: "&copy;" },
                  sx: { display: "inline-flex", mr: 0.5 }
                }
              ),
              (/* @__PURE__ */ new Date()).getFullYear(),
              " Clara"
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, sx: { mb: { xs: 1, md: 0 } }, children: [
          /* @__PURE__ */ jsx(
            StyledLink,
            {
              "data-testid": "footer-terms-and-conditions",
              href: links.terms,
              children: t("metadata.links.termslabel")
            }
          ),
          /* @__PURE__ */ jsx(StyledLink, { "data-testid": "footer-privacy", href: links.privacy, children: t("metadata.links.privacyLabel") }),
          /* @__PURE__ */ jsx(
            StyledLink,
            {
              "data-testid": "footer-help-center",
              href: links.help_center,
              sx: { display: { xs: "none", md: "inline-block" } },
              children: t("metadata.links.helpCenterLabel")
            }
          )
        ] })
      ]
    }
  );
}

export {
  Footer
};
